import { Component, OnInit, Input } from '@angular/core';
import { STRING } from '../types';

@Component({
  selector: 'app-info-widget',
  templateUrl: './info-widget.component.html',
  styleUrls: ['./info-widget.component.css']
})
export class InfoWidgetComponent implements OnInit {

  constructor() { }
  @Input() data: InfoWidget[];

  ngOnInit() {
	  console.log('InfoWidgetComponent init');
  }
}

export class InfoWidget {
	name: string;
	value: string;
	visible: any;
	constructor(opts: {name: string, value: string, visible?: any}) {
		this.visible = opts.visible === undefined ? true : opts.visible;
		Object.assign(this, opts);
		this.visible = ((typeof this.visible === STRING.FUNCTION) && this.visible) || (() => true);
	}
	get display() {
		return this.visible();
	}
}
